import JoinJobsWidget from "~/components/JoinJobsWidget";
import { getCommonSliceProps } from "~/external/prismic";
import connectSlice from "~/lib/connectSlice";

function mapSliceToProps(slice: any) {
  return {
    ...getCommonSliceProps(slice),
  };
}

export default connectSlice(mapSliceToProps)(JoinJobsWidget);
